import React, { FC, useCallback, useEffect, useState, useContext } from 'react';
import { TasksContext, TasksDispatchContext, TasksProvider, useTask } from '../stateManagement/context';
import {
    IControlMeasure,
    IControlMeasureFailureMode,
    IControlType, IFailureModeAssessment, IHarm,
    IProjectFailureMode,
    ISeverity
} from "../types/types";
import {get, post} from "../fetchers/fetchers";
 
import {useParams} from "react-router";
import {Table, TableCell, TableHead, TableRow, Typography} from "@material-ui/core";
import Harm from "./harm";

import {getHarms} from "../stateManagement/data";
import { API_URL } from "../env";
interface IRiskHarmsProps {
}

interface IRouteParams {
    id: string
}



const Harms: FC<IRiskHarmsProps> = () => {

    let dispatch = useContext(TasksDispatchContext)
    let tasks = useTask()

    const [isLoaded, setIsLoaded] = useState<boolean>(true);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [failureModes, setFailureModes] = useState<IProjectFailureMode[]>([]);
    const [severities, setSeverities] = useState<ISeverity[]>([]);
    const [failureModeAssessments, setFailureModeAssessments]= useState<IFailureModeAssessment[]>([]);
    const [reloadHarm, setReloadHarm] = useState<boolean>(false);
    const [harms, setHarms] = useState<IHarm[]>([]);

    useEffect(() => {

        if (tasks.loaded) {

            setFailureModes(tasks.failureModes)
            setFailureModeAssessments(tasks.failureModeAssessments)
            setSeverities(tasks.severity)
            setHarms(tasks.harms)

        }

    })

    const params = useParams<IRouteParams>()


    const getHarm = (failure_mode: IProjectFailureMode): IHarm => {

        let harm = harms.find(h => h.project_failure_mode_id === failure_mode.id);
        if (harm) {
            return harm
        }
        harm = {
            project_failure_mode_id: failure_mode.id
        }
        return harm
    }

    const setHarm = async (harm: IHarm) => {
        delete harm.id
        delete harm.consequence
        delete harm.consequence_id

        let d = await post<IHarm>( API_URL + "harms/" + params.id.toString() + "/", harm);
        let e = await getHarms(params.id, dispatch)
    }

    const updateHarm = useCallback((harm: IHarm) => {
        setHarm(harm).then( () => setReloadHarm(true))
    }, [setHarm, setIsLoaded, setReloadHarm]);


    return (
        <>
        <Table size="small">
            <TableHead>
                <TableCell></TableCell>
                <TableCell>Failure Mode</TableCell>
                <TableCell>Damage and Loss Severity</TableCell>
                <TableCell>Population at Risk</TableCell>
                <TableCell>Potential Loss of Life</TableCell>
                <TableCell>Economics ($)</TableCell>
                <TableCell>Environmental/Other Consequences ($)</TableCell>
                <TableCell>Special Consideration</TableCell>
                <TableCell>Special Consideration Description</TableCell>
                <TableCell>Consequence Category</TableCell>
                <TableCell>Comment</TableCell>
            </TableHead>
            {
                isLoaded && failureModes.map((f) => {
                    if (f.failure_mode?.is_active === false) { return <></> }
                    let fma = failureModeAssessments.find(fma => fma.project_failure_mode_id === f.id)
                    if (!fma) {return <></>}
                    if (fma.consider) {
                        return (
                            <Harm severities={severities}
                                  failure_mode={f}
                                  harm={getHarm(f)}
                                  updateHarm={updateHarm}/>
                        )
                    }else {
                        return <></>
                    }
                })
            }

        </Table>
            <div>
                <Typography><small>Note only included group failure modes are shown</small></Typography>
            </div>
        </>

    )

}

export default Harms